import "./verify.css";
import Topbar from "../Global/topbar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Verification from "./Verification";
import { useEffect } from "react";

export default function Verify() {
  const { state } = useLocation();
  const { data, edit2 } = state || {};
  const navigate = useNavigate();
  const notify = () => {
    const data1 = localStorage.getItem("data");
    const isotp = localStorage.getItem("isotp");
    if (data1 && isotp) {
      navigate("/admin/consultant");
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    if (!data) {
      navigate("/admin/consultant", { replace: true });
    }
  }, [data, navigate]);

  if (!data) {
    return null;
  }
  
  

  return (
    <div className="create-main-consultant">
      <div className="container-consultant">
        <Topbar />
        <div className="create-mid-consultant">
          <div className="back">
            {" "}
            <button onClick={notify} className="logout">
              {" "}
              <ArrowBackIcon style={{ fontSize: "2rem" }} />
            </button>
            <h1>Consultant Verify</h1>
          </div>
          <div>
            <a href="" style={{ display: "none" }}>
              Dashboard
            </a>{" "}
            <Link to="/admin/consultant">Consultant List</Link> &#62;{" "}
            <a href="">Consultant Verify</a>
          </div>
        </div>
        <Verification datas={data} edit2={edit2} />
      </div>
    </div>
  );
}
